/*
 *  Before removing an experiment from this file, read
 *  https://github.com/ratehub/front-end/blob/main/docs/experiments.md#how-to-remove-an-experiment
 */


// https://cms.ratehub.dev/wp-admin/edit.php?post_type=experiments
// https://cms.ratehub.ca/wp-admin/edit.php?post_type=experiments

const EXPERIMENTS = {
    approvalModel: 'cc-approval-model',             // 2025-Oct-01, to be removed by AC-407
    approvalThreshold: 'cc-approval-threshold',     // 2025-Oct-31, to be removed by AC-465
};

export default EXPERIMENTS;
